import { ROLE } from "@/utils/constant";
import { createContext } from "react";

export type Role = (typeof ROLE)[keyof typeof ROLE];
export interface User {
  id?: string;
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  roles: Role[];
}

export const AuthContext = createContext({
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  getUser: (): User => ({}) as User,
  isReady: false,
});
